// extracted by mini-css-extract-plugin
export default {"root":"Favorite__root--21u33","favorite":"Favorite__favorite--3lnbm"};